__turbopack_context__.v({
  "dummy-email-message": "OnboardingPreviewContainer-module-scss-module__yTj46G__dummy-email-message",
  "locked-veneer-layer": "OnboardingPreviewContainer-module-scss-module__yTj46G__locked-veneer-layer",
  "preview-signature-body": "OnboardingPreviewContainer-module-scss-module__yTj46G__preview-signature-body",
  "preview-signature-body-container": "OnboardingPreviewContainer-module-scss-module__yTj46G__preview-signature-body-container",
  "preview-signature-container": "OnboardingPreviewContainer-module-scss-module__yTj46G__preview-signature-container",
  "shimmer-email-signature-container": "OnboardingPreviewContainer-module-scss-module__yTj46G__shimmer-email-signature-container",
});
